import * as Api from '@ViewModels';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import hubSpotLogo from '../../../assets/hubspot_logo.jpg';
import { ApiKeyIntegrationPage } from '../ApiKeyIntegrationPage';

export function HubSpotV2() {
	const userSession = useUserSession();

	return (
		<ApiKeyIntegrationPage
			provider={Api.IntegrationProvider.HubSpot}
			integrationType={Api.ExternalIntegrationType.HubSpot}
			displayName='HubSpot'
			logo={hubSpotLogo}
			logoAlt='HubSpot CRM Logo'
			description='Levitate can sync with HubSpot CRM to pull contact information, including names, email and physical mailing addresses, phone numbers, and contact owners.'
			credentialLabel='Service Key'
			credentialNoun='service key'
			connectPrompt='To get started, a HubSpot Super Admin (or a user with Developer tools access) creates a service key under Development → Keys → Service keys, with the read scopes crm.objects.contacts.read, crm.objects.companies.read, crm.objects.owners.read, crm.lists.read, crm.schemas.contacts.read, crm.schemas.companies.read, and sales-email-read. Open the key, click Show, then Copy, and paste it below. An existing private app access token also works.'
			manageConnectedText='Your HubSpot contacts will show up in the contacts tab.'
			manageNotConnectedText='Once you are configured, your HubSpot contacts will show up in the contacts tab.'
			disconnectTitle='Disconnect HubSpot? Levitate will stop syncing contact data from your HubSpot account. You can reconnect at any time by entering your service key again.'
			onConnected={() => {
				// While impersonating, these pending actions are the admin's.
				if (!userSession.impersonationContext?.account?.id) {
					userSession.resolvePendingAction(Api.PendingActions.ConnectHubSpot);
					// So a later rejected token isn't hidden by an old dismissal.
					window.localStorage.removeItem(Api.PendingActions.ConnectHubSpot);
				}
			}}
		/>
	);
}
